<template>
    <v-app-bar class="bot-header" height="60px" dense fixed app>
        <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-icon color="#fff" dark v-bind="attrs" v-on="on"
                    >mdi-menu</v-icon
                >
            </template>
            <v-list>
                <v-list-item v-for="(item, index) in df.menu" :key="index">
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>
                        <a :href="item.href" :title="item.text">
                            {{ item.text }}
                        </a>
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <a href="/" class="logo" title="Home">
            <img src="~public/images/templates/bot-isaura.png" alt="logo" />
        </a>
        <v-spacer></v-spacer>
        <span
            v-for="(item, index) in isAuthen
                ? desktop.menu.authen
                : desktop.menu.unauthen"
            :key="index"
            :class="Array.isArray(item.children) ? 'msub' : 'mmain'"
        >
            <v-menu offset-y v-if="Array.isArray(item.children)">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn outlined dark v-bind="attrs" v-on="on">
                        <v-icon left>{{ item.icon }}</v-icon>
                        {{ item.text }}
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item
                        v-for="(child, c) in item.children"
                        :key="c"
                        :href="child.href"
                        :title="child.text"
                    >
                        <v-icon left>{{ child.icon }}</v-icon>
                        {{ child.text }}
                    </v-list-item>
                </v-list>
            </v-menu>
            <v-btn
                v-else
                :href="item.href"
                :title="item.text"
                dark
                :text="ua.headers.pageKey !== item.pageKey"
                :outlined="ua.headers.pageKey === item.pageKey"
            >
                <v-icon left>{{ item.icon }}</v-icon>
                {{ item.text }}
            </v-btn>
        </span>
        <v-spacer></v-spacer>
        <v-menu v-if="isAuthen" offset-y>
            <template v-slot:activator="{ on, attrs }">
                <v-avatar v-bind="attrs" v-on="on">
                    <img :src="ua.member.Avatar" :alt="ua.member.MemberName" />
                </v-avatar>
            </template>
            <v-list>
                <v-list-item
                    v-for="(item, index) in desktop.menu.avatar"
                    :key="index"
                >
                    <v-list-item-title>
                        <a :href="item.href" :title="item.text">
                            {{ item.text }}
                        </a>
                    </v-list-item-title>
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                </v-list-item>
            </v-list>
        </v-menu>
        <div v-else>
            <v-btn
                href="/authen/password/forgot"
                title="Quên mật khẩu"
                color="#fff"
                text
            >
                Quên mật khẩu
            </v-btn>
            <v-btn href="/authen/register" title="Đăng ký" color="#fff" text>
                Đăng ký
            </v-btn>
            <v-btn href="/authen/login" title="Đăng nhập" color="#fff" text>
                Đăng nhập
            </v-btn>
        </div>
    </v-app-bar>
</template>

<script>
const cafe = {
    default: {
        menu: {
            home: {
                icon: "mdi-home",
                text: "Trang chủ",
                href: "/",
            },
            logout: {
                icon: "mdi-logout-variant",
                href: "/authen/logout",
                text: "Đăng xuất",
            },
            password: {
                forgot: {
                    icon: "mdi-lock-reset",
                    href: "/authen/password/forgot",
                    text: "Quên mật khẩu",
                },
            },
            project: {
                list: {
                    icon: "mdi-format-list-bulleted-triangle",
                    href: "/project/list",
                    text: "Dự án của tôi",
                },
            },
            tool: {
                stock: {
                    scan: {
                        icon: "mdi-barcode-scan",
                        href: "/tool/stock/scan",
                        text: "Quét mã tồn kho",
                    },
                },
                file: {
                    metadata: {
                        icon: "mdi-text-box-outline",
                        href: "/tool/file/metadata",
                        text: "File MetaData",
                    },
                },
                qrcode: {
                    create: {
                        icon: "mdi-qrcode-plus",
                        href: "/tool/qrcode/create",
                        text: "Tạo QRCode",
                    },
                },
            },
        },
    },
};
const df = cafe.default;

export default {
    name: "HeaderMenu",

    components: {},

    data() {
        return {
            desktop: {
                menu: {
                    unauthen: [
                        df.menu.tool.stock.scan,
                        df.menu.tool.file.metadata,
                    ],
                    authen: [
                        df.menu.project.list,
                        {
                            text: "Tool",
                            icon: "mdi-tools",
                            children: [
                                df.menu.tool.stock.scan,
                                df.menu.tool.file.metadata,
                                df.menu.tool.qrcode.create,
                            ],
                        },
                    ],
                    avatar: [
                        df.menu.logout,
                        df.menu.password.forgot,
                        df.menu.project.list,
                    ],
                },
            },
            df: {
                src: "/public/images/templates/thumbnail.svg",
                menu: [
                    df.menu.home,
                    df.menu.tool.stock.scan,
                    df.menu.tool.file.metadata,
                ],
            },
        };
    },

    computed: {
        ua() {
            return this.$store.state.useragent;
        },
        isAuthen() {
            return this.ua && this.ua.member && this.ua.member.MemberID;
        },
    },

    methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.theme--light.v-app-bar.v-toolbar.v-sheet.bot-header {
    background: #FEAC5E; /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #4BC0C8, #C779D0, #FEAC5E); /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #4BC0C8, #C779D0, #FEAC5E); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.v-application .bot-header .menu a {
    color: #fff;
}

.v-application .bot-header .logo {
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-left: 20px;
    text-decoration: none;
}

.v-application .bot-header .logo img {
    max-height: 40px;
}

.v-application .bot-header .logo span {
    color: #f5d64a;
    margin-left: 10px;
}

.v-application .bot-header span.msub {
    margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// header.menu.vue